var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C19.0335 0 19.9827 0.57375 20.4748 1.4875L35.6611 29.8208C36.1321 30.6992 36.111 31.7617 35.6048 32.6188C35.0986 33.4758 34.1776 34 33.1863 34H2.81373C1.8224 34 0.90138 33.4758 0.395171 32.6188C-0.111039 31.7617 -0.13213 30.6992 0.338925 29.8208L15.5252 1.4875C16.0173 0.57375 16.9665 0 18 0ZM18 24.9333C16.7556 24.9333 15.7502 25.9462 15.7502 27.2C15.7502 28.4538 16.7556 29.4667 18 29.4667C19.2444 29.4667 20.2498 28.4538 20.2498 27.2C20.2498 25.9462 19.2444 24.9333 18 24.9333ZM18 11.3333C16.7204 11.3333 15.701 12.4313 15.7924 13.7204L16.3126 21.0871C16.3759 21.9725 17.1141 22.6667 17.993 22.6667C18.8788 22.6667 19.61 21.9796 19.6733 21.0871L20.1936 13.7204C20.285 12.4313 19.2726 11.3333 17.9859 11.3333H18Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation_icon.a8564f01f6c94a9f1274f29cbf0f9d4d.svg";
export { ForwardRef as ReactComponent };